import { RiSettings2Line } from "@itandi/itandi-bb-ui";
import clsx from "clsx";
import Link from "next/link";
import { useRouter } from "next/router";
import type React from "react";
import type { ReactNode } from "react";
import useItandiAccount from "~/hooks/useItandiAccount";
import { PATH as ADMIN_COMPANY_SETTINGS_PATH } from "~/pages/settings/admin/company_settings";
import { PATH as ADMIN_COMPANY_STORE_SETTINGS_PATH } from "~/pages/settings/admin/company_store_settings";
import { PATH as COMPANY_SETTINGS_PATH } from "~/pages/settings/company_settings";
import { PATH as COMPANY_STORE_MAILS_PATH } from "~/pages/settings/company_store_mails";
import { PATH as COMPANY_STORE_SETTINGS_PATH } from "~/pages/settings/company_store_settings";
import { PATH as COMPANY_VENDORS_PATH } from "~/pages/settings/company_vendors";
import { PATH as FILE_TEMPLATE_PATH } from "~/pages/settings/file_templates";
import { PATH as IMPORT_PATH } from "~/pages/settings/imports";
import { PATH as COMPANY_NOTIFICATION_PATH } from "~/pages/settings/notifications";
import { PATH as STAFFS_PATH } from "~/pages/settings/staffs";
import { PATH as SUBTYPE_PATH } from "~/pages/settings/subtypes";
import { showNewFeatureForLocal } from "~/utils/FeatureFlagUtil";
import { generatePath } from "~/utils/generatePath";
import Styles from "./SettingLayout.module.scss";

type Props = {
	children: ReactNode;
};

export const ClientSettingLayout: React.FC<Props> = ({ children }: Props) => {
	const { data: session } = useItandiAccount().currentAccount();
	const currentPath: string = useRouter().pathname;
	const getActiveStyles = (targetPath: string): string => {
		if (currentPath.includes(targetPath)) {
			return Styles.ActiveMenu;
		}
		return "";
	};
	if (session === null) return null;
	return (
		<div>
			<div className={Styles.SettingLayout}>
				<div className={Styles.SettingMenu}>
					<h2 className={Styles.SettingHeader}>設定</h2>
					{/* <p className={Styles.SettingSubHeader}> */}
					{/*  <RiUserLine className={Styles.HeaderIcon} /> */}
					{/*  個人設定 */}
					{/* </p> */}
					{/* <ul className={Styles.SettingList}> */}
					{/*  <li */}
					{/*    className={clsx( */}
					{/*      Styles.SettingItem, */}
					{/*      getActiveStyles(PROFILE_PATH) */}
					{/*    )} */}
					{/*  > */}
					{/*    <Link className={Styles.MenuLink} href={PROFILE_PATH}> */}
					{/*      プロフィール */}
					{/*    </Link> */}
					{/*  </li> */}
					{/* </ul> */}
					<p className={Styles.SettingSubHeader}>
						<RiSettings2Line className={Styles.HeaderIcon} />
						アカウント設定
					</p>
					<ul>
						{session.isAdmin ? (
							<li
								className={clsx(
									Styles.SettingItem,
									getActiveStyles(ADMIN_COMPANY_SETTINGS_PATH)
								)}
							>
								<Link
									className={Styles.MenuLink}
									href={ADMIN_COMPANY_SETTINGS_PATH}
								>
									会社設定
									<span className={Styles.AdminLabel}>Admin</span>
								</Link>
							</li>
						) : null}
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(COMPANY_SETTINGS_PATH)
							)}
						>
							<Link className={Styles.MenuLink} href={COMPANY_SETTINGS_PATH}>
								会社情報設定
							</Link>
						</li>
						{session.isAdmin ? (
							<li
								className={clsx(
									Styles.SettingItem,
									getActiveStyles(ADMIN_COMPANY_STORE_SETTINGS_PATH)
								)}
							>
								<Link
									className={Styles.MenuLink}
									href={ADMIN_COMPANY_STORE_SETTINGS_PATH}
								>
									店舗設定
									<span className={Styles.AdminLabel}>Admin</span>
								</Link>
							</li>
						) : null}
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(COMPANY_STORE_SETTINGS_PATH)
							)}
						>
							<Link
								className={Styles.MenuLink}
								href={COMPANY_STORE_SETTINGS_PATH}
							>
								店舗項目設定
							</Link>
						</li>
						<li
							className={clsx(Styles.SettingItem, getActiveStyles(STAFFS_PATH))}
						>
							<Link className={Styles.MenuLink} href={STAFFS_PATH}>
								担当者一覧
							</Link>
						</li>
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(COMPANY_VENDORS_PATH)
							)}
						>
							<Link className={Styles.MenuLink} href={COMPANY_VENDORS_PATH}>
								施工会社一覧
							</Link>
						</li>
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(COMPANY_STORE_MAILS_PATH)
							)}
						>
							<Link className={Styles.MenuLink} href={COMPANY_STORE_MAILS_PATH}>
								通知先メールアドレス設定
							</Link>
						</li>
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(COMPANY_NOTIFICATION_PATH)
							)}
						>
							<Link
								className={Styles.MenuLink}
								href={COMPANY_NOTIFICATION_PATH}
							>
								通知設定
							</Link>
						</li>
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(SUBTYPE_PATH)
							)}
						>
							<Link className={Styles.MenuLink} href={SUBTYPE_PATH}>
								案件タイプ設定
							</Link>
						</li>
						{session.isAdmin ? (
							<li
								className={clsx(
									Styles.SettingItem,
									getActiveStyles(IMPORT_PATH)
								)}
							>
								<Link className={Styles.MenuLink} href={IMPORT_PATH}>
									過去データ取込
									<span className={Styles.AdminLabel}>Admin</span>
								</Link>
							</li>
						) : null}
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(FILE_TEMPLATE_PATH)
							)}
						>
							<Link className={Styles.MenuLink} href={FILE_TEMPLATE_PATH}>
								帳票設定
							</Link>
						</li>
						<li
							className={clsx(
								Styles.SettingItem,
								getActiveStyles(
									generatePath("/settings/company_construction_items")
								)
							)}
						>
							<Link
								className={Styles.MenuLink}
								href={generatePath("/settings/company_construction_items")}
							>
								施工項目設定（見積・請求・精算）
							</Link>
						</li>
						{session.isAdmin && showNewFeatureForLocal() ? (
							<li
								className={clsx(
									Styles.SettingItem,
									getActiveStyles(
										generatePath("/settings/admin/company_ip_addresses")
									)
								)}
							>
								<Link
									className={Styles.MenuLink}
									href={generatePath("/settings/admin/company_ip_addresses")}
								>
									許可IPアドレス設定
									<span className={Styles.AdminLabel}>Admin</span>
								</Link>
							</li>
						) : null}
						{/* <li */}
						{/*  className={clsx( */}
						{/*    Styles.SettingItem, */}
						{/*    getActiveStyles("") */}
						{/*  )} */}
						{/* > */}
						{/*  <Link  className={Styles.MenuLink} href={""}> */}
						{/*    ユーザー */}
						{/*  </Link> */}
						{/* </li> */}
						{/* <li */}
						{/*  className={clsx( */}
						{/*    Styles.SettingItem, */}
						{/*    getActiveStyles("") */}
						{/*  )} */}
						{/* > */}
						{/*  <Link className={Styles.MenuLink} href={""}> */}
						{/*    協力会社 */}
						{/*  </Link> */}
						{/* </li> */}
					</ul>
				</div>
				<div className={Styles.SettingCompanyContent}>{children}</div>
			</div>
		</div>
	);
};
